import React, { createContext, useReducer } from 'react';
import reducer, { initialState } from './reducers/create-shift.reducer';

const CreateShiftStateContext = createContext(null);
const CreateShiftDispatchContext = createContext(null);

function CreateShiftProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState, undefined);

  return (
    <CreateShiftStateContext.Provider value={state}>
      <CreateShiftDispatchContext.Provider value={dispatch}>{children}</CreateShiftDispatchContext.Provider>
    </CreateShiftStateContext.Provider>
  );
}

export { CreateShiftProvider, CreateShiftStateContext, CreateShiftDispatchContext };
